export interface updateLeagueState {
    updateLeagueData: any[];
    responceStatus: boolean;
    error: null | string;
}


export enum updateLeagueActionTypes {
    FETCH_UPDATE_LEAGUE_DATA = "FETCH_UPDATE_LEAGUE_DATA",
    FETCH_UPDATE_LEAGUE_DATA_SUCCESS = "FETCH_UPDATE_LEAGUE_DATA_SUCCESS",
    FETCH_UPDATE_LEAGUE_DATA_ERROR = "FETCH_UPDATE_LEAGUE_DATA_ERROR",
}

export type updateLeagueAction =
    | { type: updateLeagueActionTypes.FETCH_UPDATE_LEAGUE_DATA }
    | { type: updateLeagueActionTypes.FETCH_UPDATE_LEAGUE_DATA_SUCCESS; payload: any[] }
    | { type: updateLeagueActionTypes.FETCH_UPDATE_LEAGUE_DATA_ERROR; payload: string };